import { render, staticRenderFns } from "./approveDia.vue?vue&type=template&id=5ee720e2&scoped=true"
import script from "./approveDia.vue?vue&type=script&lang=js"
export * from "./approveDia.vue?vue&type=script&lang=js"
import style0 from "./approveDia.vue?vue&type=style&index=0&id=5ee720e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee720e2",
  null
  
)

export default component.exports